### global require, ga, _hmt ###

require 'plugins/pure/pure-min.css'

require 'plugins/flexslider/flexslider.css'
require 'plugins/slick-carousel/slick/slick.css'
require 'plugins/sweetalert/lib/sweet-alert.css'
require 'plugins/swiper/dist/css/swiper.min.css'
require 'styles/common/util.scss'
require 'styles/common/common1.scss'
require 'styles/common/baoming.scss'
require 'plugins/slide/index.css'
require 'plugins/slide/slide.css'
require 'plugins/icomoon/style.css'
require 'styles/pages/content-jingxuan.scss'

require 'script!jquery'
require 'script!affix'
require 'script!flexslider'
require 'script!plugins/scrollspy.js'
require 'script!plugins/swiper/dist/js/swiper.jquery.js'
require 'script!plugins/slide/slide.min.js'
require '../common/fast-nav.coffee'
require '../common/city.coffee'


###
# flexslider
###
$ ->
  $human = $('#human')
  $carousel = $('.carousel')
  $nav = $('.nav')
  $nav_li = $nav.find 'li'

  $human.flexslider {
    animation: 'slide'
    animationLoop: false
    controlNav: false
    itemWidth: 254
    itemMargin: 28
    moflexsliderve: 1
    prevText: ""
    nextText: ""
  }
  $human1 = $('#human1')

  $human1.flexslider {
    animation: 'slide'
    animationLoop: false
    controlNav: false
    itemWidth: 340
    itemMargin: 39
    move: 3
    prevText: ""
    nextText: ""
    useCSS : true
  }
  $experience = $('#experience')

  $experience.flexslider {
    animation: 'slide'
    animationLoop: false
    controlNav: false
    itemWidth:1100
    itemMargin:0
    move:1
    prevText: ""
    nextText: ""
    useCSS : true
  }

  $navs = $('#navs')
  $navs.flexslider {
    animation: 'slide'
    animationLoop: false
    controlNav: false
    itemWidth:1100
    itemMargin:0
    move: 1
    prevText: ""
    nextText: ""
  }

  $navss= $('#navss')
  $navss.flexslider {
    animation: 'slide'
    animationLoop: false
    controlNav: false
    itemWidth:1100
    itemMargin:0
    move: 1
    prevText: ""
    nextText: ""
  }

  $navs0 = $('#navs0')

  $navs0.flexslider {
    animation: 'slide'
    animationLoop: false
    controlNav: false
    itemWidth:1100
    itemMargin:0
    prevText: ""
    nextText: ""
  }
  $navs1 = $('#navs1')

  $navs1.flexslider {
    animation: 'slide'
    animationLoop: false
    controlNav: false
    itemWidth: 1100
    itemMargin:0
    move: 1
    prevText: ""
    nextText: ""
  }
  $navs2 = $('#navs2')

  $navs2.flexslider {
    animation: 'slide'
    animationLoop: false
    controlNav: false
    itemWidth: 1100
    itemMargin: 0
    move: 1
    prevText: ""
    nextText: ""
  }
  $navs3 = $('#navs3')

  $navs3.flexslider {
    animation: 'slide'
    animationLoop: false
    controlNav: false
    itemWidth: 1100
    itemMargin: 0
    move: 1
    prevText: ""
    nextText: ""
  }
  $navs4 = $('#navs4')

  $navs4.flexslider {
    animation: 'slide'
    animationLoop: false
    controlNav: false
    itemWidth: 1100
    itemMargin: 0
    move: 1
    prevText: ""
    nextText: ""
  }

  $carousel.slick {
    centerMode: true
    centerPadding: '0px'
    slidesToShow: 3
    speed: 600
    arrows: false
  }

  $carousel.css 'opacity','1'


  $('#slide3d').slideCarsousel {
    slideType:'3d'
    indicatorEvent:'mouseover'
  }
  $('#slide3d2').slideCarsousel {
    slideType:'3d'
    indicatorEvent:'mouseover'
  }
  $('#slide3d3').slideCarsousel {
    slideType:'3d'
    indicatorEvent:'mouseover'
  }
###
# 5不限(切换)
###

do->

  if $('.material1').length > 0
    $material1 = $('.material1')
    $imageContainer = $material1.find '.image'
    $textContainer = $material1.find '.text'
    $textContainerswiper = $material1.find '.text ul'
    $paginations = $material1.find '.material_nav1'
    $pagination = $material1.find '.material_nav1 li'
    $speed = 800
    $autoplay = 5000
    $imageOptions = {
      autoplay: $autoplay,
      speed: $speed,
      loop: true,
      effect: 'fade'
    }
    $swiperI = new Swiper $imageContainer,$imageOptions
    $textOptions = {
      autoplay: $autoplay,
      autoHeight: true,
      speed: $speed,
      effect: 'fade'
      fade: {
        crossFade: true,
      },
      loop: true,
      onSlideChangeStart: (swiper) ->
        $index = swiper.activeIndex
        if $index >= $pagination.length
          $index = $index - $pagination.length
        $pagination.removeClass 'active'
        $pagination.eq($index - 1).addClass 'active'
        $swiperI.slideTo($index)
    }
    $swiperT = new Swiper $textContainer,$textOptions
    theSwitch = () ->
      $this = $(this)
      $swiperI.slideTo($this.index()+1)
      $swiperT.slideTo($this.index()+1)
      $this.siblings().removeClass 'active'
      $this.addClass 'active'
    $pagination.on 'click', theSwitch

###
# afterSale toggle
###
do->
  $afterSale_li = $('.afterSale ul li')

  $afterSale_li.hover (evt)->
    evt.preventDefault()
    $me = $(this)
    $afterSale_li.removeClass 'active'
    $me.addClass 'active'

  ###
  # 导航浮动浏览器
  ###
  $topbg_nav = $('.topbg-nav')

  $topbg_nav.affix {
    offset:
      top: 684
  }

  ###
  # 滚动锚点
  ###

  scroll = require '../common/scroll.coffee'

  $topbg_nav.find('li a').on 'click',(evt)->
    evt.preventDefault()

    $me = $(this)
    scroll.scrollTo $($me.attr('href'))

do ->
  $leftFloat=$('.left-float')
  $yuyuefix=$('.yuyuefix')
  $mfdh=$('.mfdh')
  if $yuyuefix.length>0
    iHeight = $leftFloat.offset().top
    $height=$("body").height()-($(window).height()-136)
    $(window).scroll ->
      $mfdh.hide()
      $mfdh.stop().animate right : -150
      scrollTop = $(window).scrollTop()
      if $height<=scrollTop
        $yuyuefix.stop().animate(bottom:-85,50)
      else if  480<= scrollTop
        $leftFloat.addClass 'show'
        $yuyuefix.stop().animate(bottom:0,50)
      else
        $leftFloat.removeClass 'show'
        $yuyuefix.stop().animate(bottom:-85,50)

      if $('#left-float').hasClass 'show'
        $('.rengongkefu').addClass 'full'
      else
        $('.rengongkefu').removeClass 'full'



/** WEBPACK FOOTER **
 ** /root/workspace/jimujia-pc_4ez2/wwwroot/static/~/coffeelint-loader!./content-jingxuan.coffee
 **/